module.exports = __webpack_public_path__ + "vue-app/img/vols-3.6b55a3a9.jpg";